import { videoFavoriteState, videoLikedState } from 'constant/video'
import CoverImage from '../CoverImage'
import InfoWrapper from '../InfoWrapper'
import Toolbar from '../Toolbar'
import UploaderInfo from '../UploaderInfo'
import { StyledVirtualPage } from './Styled'
import { useSelector } from 'react-redux'
import { selectTopicList } from 'redux/selector/app'

interface PlaceHolderPageProps {
  videoInfo: any
  onBase64ImageLoad?: any
  posterSrc?: string | null | false
  onLike?: () => void
  onSave?: () => void
}

const PlaceHolderPage = ({ videoInfo, onBase64ImageLoad, posterSrc = null, onLike, onSave }: PlaceHolderPageProps) => {
  const topicList = useSelector(selectTopicList)

  let topics: any[] = []

  if (videoInfo) {
    topics =
      videoInfo.topic_ids
        ?.map((id: any) => {
          const topicItem = topicList.find((t: any) => t.id === id)
          if (topicItem) {
            return {
              text: '#' + topicItem.name,
              params: {
                topic_ids: String(topicItem.id),
              },
            }
          } else {
            return null
          }
        })
        .filter((text: any) => text != null) ?? []
  }
  return (
    <StyledVirtualPage>
      <InfoWrapper>
        <CoverImage
          src={posterSrc as string | null}
          onBase64ImageLoad={onBase64ImageLoad}
          base64SrcSource={videoInfo.coverphoto_v}
        />
        <UploaderInfo topics={topics} uploader={'@' + videoInfo.uploader_name} videoName={videoInfo.title} />
      </InfoWrapper>
      <Toolbar
        key={videoInfo.id}
        liked={videoInfo.like === videoLikedState.TRUE}
        saved={videoInfo.favorite === videoFavoriteState.TRUE}
        likeCount={videoInfo.like_count}
        saveCount={videoInfo.favorite_count}
        onLike={onLike}
        onSave={onSave}
      />
    </StyledVirtualPage>
  )
}

export default PlaceHolderPage
